import apiClient from "../common/apiClient.js";

export default class WhatsAppController {
  // tenant/whatsApp
  async whatsAppInit(userId, token) {
    try {
      return await apiClient.get("/tenant/whatsApp-init/" + userId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async checkLoginStatus(userId, token) {
    try {
      return await apiClient.get("/checkLoginStatus/" + userId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async getQr(userId, token) {
    try {
      return await apiClient.get("/send-qr/" + userId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
